"use client";
import React from "react";
import TextSection from "@/library/sections/texts/TextSection";

export default function TextSectionBlock({ blok }) {
  return (
    <TextSection
      blok={blok}
      title={blok.title}
      content={blok.content}
      titleAs={blok.titleAs}
      titleColor={blok.titleColor}
      contentColor={blok.contentColor}
      backgroundColor={blok.backgroundColor}
    />
  );
}
